// Settings.tsx

import React, { useState } from 'react';
import Header from './Header.tsx';
import Sidebar from './Sidebar.tsx';
import user_plus from '../Images/user-plus.svg';
import styles from './Settings.module.css';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import Modal from './Modal.tsx';
import { FaRegBuilding } from 'react-icons/fa';

function Settings() {
  const [showSidebar, setShowSidebar] = useState(true);
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [openClient, setOpenClient] = useState(false);

  // Handlers to open modals
  const handleModalOpen = () => {
    setOpen(true);
  };

  const handleModalOpenClient = () => {
    setOpenClient(true);
  };

  return (
    <section className={styles.section}>
      <div className={styles.profile}>
        {/* Header Component */}
        <Header title="Settings" setShowSidebar={setShowSidebar} showSidebar={showSidebar} />

        <div className={styles.container}>
          {/* Sidebar */}
          <div
            className={styles.sidebarStyle}
            style={{
              width: showSidebar ? '240px' : '0',
              transition: 'width 0.3s',
            }}
          >
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className={styles.mainContentStyle}>
            {/* Top Navigation */}
            <div className={styles.topNav}>
              <nav className={styles.nav}>
                <ul>
                  <li>
                    <NavLink
                      to="users"
                      className={({ isActive }) => (isActive ? styles.activeLink : styles.link)}
                    >
                      Users Management
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="clients"
                      className={({ isActive }) => (isActive ? styles.activeLink : styles.link)}
                    >
                      Organizations Management
                    </NavLink>
                  </li>
                </ul>
              </nav>

              {/* Conditional Add Button */}
              {pathname.includes('/users') ? (
                <button className={styles.add_user} onClick={handleModalOpen} aria-label="Add User">
                  <img src={user_plus} alt="Add User Icon" className={styles.user_img} />
                  Add User
                </button>
              ) : (
                <button
                  className={styles.add_user}
                  onClick={handleModalOpenClient}
                  aria-label="Add Organization"
                >
                  <FaRegBuilding style={{ marginRight: '8px' }} />
                  Add Organization
                </button>
              )}
            </div>

            {/* Outlet for Nested Routes */}
            <Outlet />

            {/* Modals */}
            {open && <Modal open={open} setOpen={setOpen} />}
            {openClient && (
              <Modal
                openClient={openClient}
                setOpenClient={setOpenClient}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Settings;
